// Tiny event-based toast bus. We don't pull in a UI library for this — one
// component subscribes to the bus, every call site uses showToast(...). All
// dashboard mutations should funnel error feedback through this so users
// never see a silent failure.

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
}

type Listener = (toasts: Toast[]) => void;

let nextId = 1;
let toasts: Toast[] = [];
const listeners = new Set<Listener>();

function emit(): void {
  for (const l of listeners) l(toasts);
}

export function showToast(kind: ToastKind, message: string, ttlMs = 5_000): void {
  const id = nextId++;
  toasts = [...toasts, { id, kind, message }];
  emit();
  if (ttlMs > 0) {
    window.setTimeout(() => {
      dismissToast(id);
    }, ttlMs);
  }
}

export function dismissToast(id: number): void {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function subscribeToasts(fn: Listener): () => void {
  listeners.add(fn);
  fn(toasts);
  return () => {
    listeners.delete(fn);
  };
}
